import React, { useState, useRef, useEffect } from 'react';
import { useNotifications } from '../../hooks/useNotifications';
import { Bell } from 'lucide-react';
import { NotificationDropdown } from './NotificationDropdown';
import { Button } from '../ui/button';

export const NotificationIcon: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { unreadCount } = useNotifications();
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <Button 
                variant="outline" 
                size="icon" 
                onClick={toggleDropdown} 
                className="relative"
            >
                <Bell className="h-5 w-5" />
                {unreadCount !== undefined && unreadCount > 0 && (
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                        <span className="text-white text-[10px] font-bold">{unreadCount}</span>
                    </div>
                )}
            </Button>
            {isOpen && <NotificationDropdown onClose={() => setIsOpen(false)} />}
        </div>
    );
};
